import React, { forwardRef, useMemo, useState, useEffect, useCallback } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import RunZeroMappingForm from './RunZeroMappingForm';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import message from 'components/CustomMessage';
import { Form } from 'antd';
import _, { isEmpty } from 'lodash';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';

function RunZeroCredentialsForm(props, ref) {
    const [form] = Form.useForm();
    const [checked, setChecked] = useState(props.config?.fetchAssets === "true" || Boolean(props.config?.assetOrganisationId));
    const [disabled] = useState(props.config?.assetOrganisationId);
    const featureFlags = useFeatureFlag();

    const [projects, setProjects] = useState(() => {
        if (props.config?.assetOrganisationId) {
          const { assetOrganisationId, assetOrganisationName } = props.config;
          const projectIdArray = assetOrganisationId.split(',');
          const projectNameArray = assetOrganisationName.split(',');
          return projectIdArray.map((id, index) => ({id, name: projectNameArray[index]}))
        }
        return [];
      });
    const [token, setToken] = useState();

    useEffect(() => {
        const { apiEndpoint, apiToken } = form.getFieldsValue();
        if(checked && apiToken){
        const { promise, cancel } = ToolsIntegrationsAPI.getRunzeroOrgs({apiToken, ...(apiEndpoint ? {apiEndpoint} : {})});
        promise.then((response) => {
          const { projects } = response;
          setProjects(projects);
        }).catch(() => {
          message.error('Problem fetching organizations');
        });
    
        return cancel;
    }
      }, [form, checked]);

    const fields = useMemo(() => (
        [{
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules:[urlRegexValidator],
        },
        {
            name: "apiToken",
            label: "API Token",
            required: true,
            type: FieldTypes.PASSWORD,
            props: {
                onChange: (e) => setToken(e.target.value) 
            }
        },
        ...(featureFlags.RBVM_ASSETS
            ? [
                {
                  name: "fetchAssets",
                  label: "Fetch Assets",
                  type: FieldTypes.BOOLEAN,
                  inline: true,
                  disabled: !token,
                  props: {
                    onChange: (e) => setChecked(e.target.checked),
                  },
                },
                ...(checked
                  ? [
                      {
                        name: "assetOrganisationId",
                        type: FieldTypes.MULTI_SELECT,
                        options: projects,
                        label: "Organization Name",
                        disabled: disabled && !token,
                        required: true,
                      },
                      {
                        name: "search",
                        label: "Search",
                        NoDefaultLengthRule: true,
                        rules: [
                          { max: 512, message: "Maximum length is 512 characters" },
                        ],
                        disabled: disabled && !token,
                        help: (
                          <a
                            href={
                              "https://www.runzero.com/docs/search-query-assets/"
                            }
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            https://www.runzero.com/docs/search-query-assets/
                          </a>
                        ),
                      },
                    ]
                  : []),
              ]
            : []),
        ]
    ),[projects, token, disabled, checked, featureFlags.RBVM_ASSETS]);

    const parseExtraFields = useCallback((config) => {
      return {
        ...config,
        fetchAssets: config.fetchAssets === "true" || Boolean(config.assetOrganisationId),
        assetOrganisationId: !isEmpty(config.assetOrganisationId) ? config.assetOrganisationId.split(',') : undefined,
      }
    }, [])

    const beforeSave = useCallback((data) => {
        const { assetOrganisationId } = data
        if(assetOrganisationId){
            const orgData = projects.reduce((acc,cv) =>{
                const { id, name } = cv;
                if(assetOrganisationId.includes(id)){
                acc.id.push(id);
                acc.name.push(name);
                }
                return acc;
            },{id:[],name:[]})
            return {
                ...data,
                assetOrganisationId: _.isEmpty(orgData.id) ? null : orgData.id.join(),
                assetOrganisationName: _.isEmpty(orgData.name) ? null : orgData.name.join()
            }
        }
        return data
    }, [projects]);


    return (
        <GenericPullCredentialsForm
            beforeSave={beforeSave}
            parseExtraFields={parseExtraFields}
            {...props}
            ref={ref}
            form={form}
            fields={fields}
            MappingForm={RunZeroMappingForm}
            initialValue={{ apiEndpoint: 'https://console.runzero.com/api/v1.0' }}
        />
    )
}

export default forwardRef(RunZeroCredentialsForm);